import { EnvironmentModel } from '@prime-platform/shared';

export const environment: EnvironmentModel = {
  production: false,
  sentryTraceSampleRate: 1.0,
  sentryDSN: process.env['SENTRY_DSN'] as string,
  apiUrl: process.env['API_URL'] as string,
  apiSecret: process.env['API_SECRET'] as string,
  platform: 'gsk-prime',
  appTitle: process.env['APP_TITLE'] as string,
  appSubtitle: process.env['APP_SUBTITLE'] as string,
  displayAllSearchFilters: true,
};
